//@ts-nocheck
import React from 'react';
import { Check, Info, X, Plus } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { experian, equifax } from '../assets';

// Dialog component
const Dialog = ({ open, onOpenChange, children }) => {
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 bg-black/50 flex items-center justify-center p-4">
      <div className="bg-white rounded-lg shadow-lg max-w-md w-full max-h-[90vh] overflow-y-auto">
        {children}
      </div>
    </div>
  );
};

// DialogContent component
const DialogContent = ({ children, className = "", onClose }) => {
  return (
    <div className={`p-6 ${className} relative`}>
      {children}
      <button 
        onClick={onClose}
        className="absolute top-2 right-2 p-2 rounded-full hover:bg-gray-100 transition-colors"
      >
        <X className="h-5 w-5 text-black" />
      </button>
    </div>
  );
};

// DialogHeader component
const DialogHeader = ({ children }) => {
  return (
    <div className="mb-4">
      {children}
    </div>
  );
};

// DialogTitle component
const DialogTitle = ({ children }) => {
  return (
    <h2 className="text-lg font-semibold text-black">
      {children}
    </h2>
  );
};

const features = [
  "Full PDF Credit Reports",
  "Reports from Multiple Bureaus",
  "Real-Time Credit Monitoring",
  "Tradeline Reporting Tools",
  "Dispute Resolution Services",
  "Exclusive Early Access",
  
];

const PricingWithComparison = () => {
  const navigate = useNavigate();
  const [showModal, setShowModal] = React.useState(false);

  const handleSubscribeClick = () => {
    // Logic for subscription (you can replace with actual subscription logic)
    console.log('Subscribed!');
  };

  const handleSeeHowItWorksClick = () => {
    navigate('/SeeHowItWorks');
  };

  const handleSeeSamplesClick = () => {
    navigate('/SeeSample');
   };

  return (
    <>
      <Dialog open={showModal} onOpenChange={setShowModal}>
        <DialogContent onClose={() => setShowModal(false)}>
          <DialogHeader>
            <DialogTitle>Exclusive Early Access</DialogTitle>
          </DialogHeader>
          <div className="space-y-4 text-black">
            <p>Be among the first 500,000 businesses to gain executive-level access to upcoming FuteurAI innovations, including:</p>
            <ul className="space-y-2 pl-6">
              <li className="list-disc">
                <span className="font-semibold">Futeur Intelligence:</span> Advanced AI tools tailored to your business needs.
              </li>
              <li className="list-disc">
                <span className="font-semibold">Digital Banking Products:</span> Access to our suite of digital banking solutions designed for seamless financial management.
              </li>
            </ul>
          </div>
        </DialogContent>
      </Dialog>
   
      <div className="relative py-5 px-4 sm:px-6 lg:px-8 bg-[#ffffff]">
        <div className="max-w-6xl mx-auto">
          <h2 className="text-3xl sm:text-4xl md:text-6xl lg:text-5xl xl:text-6xl font-bold text-center mb-4 sm:mb-6 lg:mb-8 text-black">
            Transform Business Credit Management with FuteurAI
          </h2>

          <p className="text-base sm:text-lg md:text-xl text-center mb-6 sm:mb-8 lg:mb-12 text-black">
            FuteurAI unites the power of Experian, Equifax, and Dun & Bradstreet into one AI-driven platform. Rooted in innovation and trust, we offer comprehensive business credit monitoring with transparency and unmatched value for every business.
          </p>

          <div className="grid grid-cols-1 lg:grid-cols-[1fr,auto,1fr] gap-6 lg:gap-8 mb-8 sm:mb-12 lg:mb-16">
            {/* FuteurAI Side */}
            <div className="bg-white rounded-xl shadow-lg p-4 sm:p-6 lg:p-8">
              <div className="flex flex-col sm:flex-row items-center sm:items-start gap-4 mb-6">
                <div className="w-16 h-16 sm:w-20 sm:h-20 bg-[#1111] rounded-lg flex items-center justify-center flex-shrink-0">
                  <img
                    src="/icon.png"
                    alt="FuteurAI Logo"
                    width={62}
                    height={62}
                    className="invert w-12 h-12 sm:w-14 sm:h-14"
                  />
                </div>
                <div className="text-center sm:text-left">
               
                <h3 className="font-bold text-xl sm:text-2xl mb-1 text-black">Infinity Access Plan</h3>
                 
                  <p className="text-base sm:text-lg text-black">$32/month for unlimited reports</p>
                </div>
              </div>

              <div className="space-y-3 sm:space-y-4">
                {features.map((feature) => (
                  <div key={feature} className="flex items-center gap-2">
                    <Check className="text-green-600 w-5 h-5 flex-shrink-0" />
                    <span className="text-black text-sm sm:text-base font-medium">{feature}</span>
                  </div>
                ))}
              </div>
              <div className="bg-[#1111] p-4 sm:p-6 md:p-8 text-center mt-6 rounded-xl">
              <div className="flex flex-col space-y-3 w-full">
                <button
                  className="bg-black text-white px-6 py-3 text-sm sm:text-base font-semibold rounded-xl hover:bg-gray-800 transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-900 shadow-md hover:shadow-lg"
                  onClick={handleSubscribeClick}
                >
                  Subscribe Now
                </button>
                <button
                  className="bg-black text-white px-6 py-3 text-sm sm:text-base font-semibold rounded-xl hover:bg-gray-800 transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-900 shadow-md hover:shadow-lg"
                  onClick={handleSeeHowItWorksClick}
                >
                  See How It Works
                </button>
                <button
                  className="bg-black text-white px-6 py-3 text-sm sm:text-base font-semibold rounded-xl hover:bg-gray-800 transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-900 shadow-md hover:shadow-lg"
                  onClick={handleSeeSamplesClick}
                >
                  See Samples
                </button>
              </div>

              <p className="mt-4 text-xs sm:text-sm text-gray-600">
                Experience unparalleled support and innovation with FuteurAI's Infinity Access plan - 
                your gateway to infinite growth and success.
              </p>
            </div>
            </div>

            {/* Versus Divider */}
            <div className="flex items-center justify-center">
            <img
              src="/vs.svg"
              alt="Versus Icon"
              className="w-20 h-20"/>
            </div>

            {/* Competitors Side */}
            <div className="bg-white rounded-xl shadow-lg p-4 sm:p-6 lg:p-8 space-y-4 sm:space-y-6">
              <div className="bg-[#1111] text-black rounded-xl p-4 flex items-center">
                <div className="flex flex-col sm:flex-row items-center sm:items-center gap-2 sm:gap-4 w-full">
                  <img
                    src="/collab/Experian.svg"
                    alt="Experian Logo"
                    className="object-contain w-24 sm:w-32 md:w-40"
                  />
                  <div className="flex-grow text-center sm:text-right">
                    <h3 className="font-bold text-black text-base sm:text-lg">Experian</h3>
                    <p className='text-black text-sm sm:text-base'>$39.95/report</p>
                  </div>
                </div>
              </div>

              <div className="flex items-center justify-center">
                <Plus className="w-6 h-6 sm:w-8 sm:h-8 text-black" />
              </div>

              <div className="bg-black text-white rounded-xl p-4 flex items-center">
                <div className="flex flex-col sm:flex-row items-center sm:items-center gap-2 sm:gap-4 w-full">
                  <img
                    src="/collab/Dun.svg"
                    alt="Dun and Bradstreet Logo"
                    className="object-contain w-24 sm:w-32 md:w-40"
                  />
                  <div className="flex-grow text-center sm:text-right">
                    <h3 className="font-bold text-white text-base sm:text-lg">Dun and Bradstreet</h3>
                    <p className='text-white text-sm sm:text-base'>$49.00/month</p>
                  </div>
                </div>
              </div>

              <div className="flex items-center justify-center">
                <Plus className="w-6 h-6 sm:w-8 sm:h-8 text-black" />
              </div>

              <div className="bg-[#1111] text-black rounded-xl p-4 flex items-center">
                <div className="flex flex-col sm:flex-row items-center sm:items-center gap-2 sm:gap-4 w-full">
                  <img
                    src="/collab/Equifax.svg"
                    alt="Equifax Logo"
                    className="object-contain w-24 sm:w-32 md:w-40"
                  />
                  <div className="flex-grow text-center sm:text-right">
                    <h3 className="font-bold text-black text-base sm:text-lg">Equifax</h3>
                    <p className='text-black text-sm sm:text-base'>$99.95/report</p>
                  </div>
                </div>
              </div>

              <div className="border-t-2 border-dashed border-gray-300 pt-4 mt-4 sm:mt-6">
                <div className="text-xl sm:text-2xl font-bold text-black text-center">
                  = $188.45/month 
                </div>
              </div>
            </div>
          </div>

          {/* Bottom Info 
          <div className="bg-[#f0f5ff] rounded-xl p-4 sm:p-6 lg:p-8 text-center">
            <h3 className="text-lg sm:text-xl lg:text-2xl font-bold mb-2 sm:mb-4 text-black">
              FuteurAI also eliminates the Hassle Tax.
            </h3>
            <p className="text-sm sm:text-base lg:text-lg mb-2 sm:mb-4 text-black">
              There's no more paying separate bills, managing multiple accounts, dealing with different 
              support teams, or tracking expenses across vendors...
            </p>
            <p className="text-base sm:text-lg lg:text-xl font-bold text-black">
              The benefits of FuteurAI go beyond price.
            </p>
          </div>*/}
        </div> 
       
      </div>
    </>
  );
};

export default PricingWithComparison;
